// Libraries
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const FixedHeader = styled.div`
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.color.crusherDashboard.maintenance.backgroundColor};
  z-index: 2;
`;

export const ScrollableContent = styled.div`
  flex-grow: 1;
`;

export const Separator = styled.div`
  margin: 24px 0;
`;
